export const route = {
  component: () => import('./page.vue'),
  path: '/records/:type(all|mine|unassigned)?',
  props: true,
  name: 'records',
  meta: {
    title: '记录',
    auth: true,
  },
};

export const tab = {
  label: route.meta.title,
  icon: 'clock-o',
  to: {
    name: route.name,
  },
};
